<template>
    <div class="fhv-centent">
        <h4 class="title-topic">Auto Channel 2.4GHz</h4>
        <el-alert title="Some parameters in subRouter mode are forbidden to be modified!" type="warning" show-icon
        :closable="false" v-if="$G_DEVICE_CFG.isSubRouter"></el-alert>
        <el-form 
        label-width="50px" 
        label-position="left"
        size="mini"
        :disabled="$G_DEVICE_CFG.isReadOnly || $G_DEVICE_CFG.isSubRouter"
        v-loading="getLoad"
        >
            <el-form-item>
                <el-radio v-model="autoChannelRadio" label="0">Thailand Standard(Recommend:Ch.1-11)</el-radio>
            </el-form-item>
            <el-form-item>
                <el-radio v-model="autoChannelRadio" label="1">Customize</el-radio>
            </el-form-item>
            <el-form-item v-if="autoChannelRadio === '1'">
                <el-checkbox-group v-model="autoChannelArr" class="fh-channel-group">
                    <el-checkbox :label="channel" v-for="channel in defaultArr" :key="channel">Channel {{channel}}</el-checkbox>
                </el-checkbox-group>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="setData">Apply</el-button>
                <el-button type="primary" @click="getData">Refresh</el-button>
            </el-form-item>
        </el-form>
    </div>
</template>

<script>
    const bit = [0,0,0,0,0,0,0,0,0,0,0,0,0,0]
    export default {
        data() {
            return {
                getLoad:false,
                autoChannelRadio: '0',
                autoChannelArr:[],
                defaultArr:[1,2,3,4,5,6,7,8,9,10,11,12,13,14]
            }
        },
        created(){
            this.getData()
        },
        methods: {
            getData() {
                this.getLoad = true
                axios
                .post("/JSONAPI",{
                    cmdType:'GET_AIS_AUTO_CHANNEL',
                    wlIndex:1
                })
                .then((response)=>{
                    this.getLoad = false
                    if(response.data.ret === 0)
                    {
                        let channel_sum = response.data.channelNum
                        this.autoChannelRadio = channel_sum === 2047 ? '0' : '1'
                        for (var i = 0; i < bit.length; i++) {
                            if (parseInt(channel_sum) & (1 << i))
                                this.autoChannelArr.push(i + 1)
                        }
                    } 
                })
                
            },
            setData() {
                let result_value,checkArray
                if(this.autoChannelRadio === '1')
                {
                    checkArray = bit.concat()
                    this.autoChannelArr.forEach((e)=>{
                        checkArray[e - 1] = 1;
                    })
                    result_value = 0
                    for (var i = 0; i < bit.length; i++) {
                        if (checkArray[i]) {
                            result_value = result_value | (1 << (i))
                        }
                    }
                    if(0 === result_value)
                    {
                        this.$message.error("Please select at least one channel!")
                    }
                }
                else
                {
                    result_value = 2047
                }
                const loadingInstance = this.$loading({lock: true})
                axios
                .post("/JSONAPI",{
                    cmdType:'SET_AIS_AUTO_CHANNEL',
                    channelNum:result_value,
                    wlIndex:1
                })
                .then((response)=>{
                    setTimeout(()=>{
                        loadingInstance.close()
                        if(response.data.ret === 0)
                            this.$message.success("Configuration is successful!")
                        else
                            this.$message.error(`Configuration failed! Error:${response.data.errMsg}`)
                    },3000)
                })
                
            }
        },
    }
</script>

<style scoped>
.fh-channel-group{
    margin-left: 50px;
}
.fh-channel-group>.el-checkbox{
    display: block;
}
.fh-channel-group>.el-checkbox + .el-checkbox{
    margin-left: 0px;
}
</style>